import { render } from "./QuorumResultModal.vue?vue&type=template&id=621d6d08&scoped=true"
import script from "./QuorumResultModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./QuorumResultModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./QuorumResultModal.vue?vue&type=style&index=0&id=621d6d08&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621d6d08"]])

export default __exports__